import { Box } from '@mui/material'
import { PipelineStatus } from './PipelineStatus'
import { UploadStage } from './UploadStage'
import { AssetUploadProps } from './types'

export function AssetUpload({ treeId, versionId }: AssetUploadProps) {
  return (
    <Box>
      <PipelineStatus treeId={treeId} versionId={versionId} />
      <UploadStage treeId={treeId} versionId={versionId} />
    </Box>
  )
}
